import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import Sidebar from "../Navigations/Sidebar";
import AccountList from "./AccountList";
import SelectedBusiness from "../Shared/SelectedBusiness";
import usePageTitle from "../../hooks/usePageTitle";

const MerchantSetup: React.FC = () => {
  const { user } = useAuth();

  usePageTitle("Accounts Setup");

  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <div className="app-layout">
      <Sidebar currentPage="/accounts-setup" />

      <div className="main-content">
        {/*<div className="dashboard-content">
          <div className="settings-container">
          </div>
        </div>*/}
        <div className="page-header">
          <h2>⚙️ Accounts Setup</h2>
          <p>
            Manage account and terminals for business{" "}
            {user?.SelectedBusiness?.name}
          </p>
          {/*<SelectedBusiness business={user?.SelectedBusiness} />*/}
        </div>

        {showSuccess && (
          <div className="success-message">
            ✅ Terminal settings saved successfully!
          </div>
        )}

        {/* Account List */}
        <AccountList businessId={user?.SelectedBusiness?.id || ""} />
      </div>
    </div>
  );
};

export default MerchantSetup;
